import phpRequest from './headRequest'
const qs = require("qs")
var request;
//退出
export function logout(params) {
  return phpRequest({
    url: '/phpcas/auth/logout',
    method: 'get'
  })
}

//修改密码
export function updatePwd(params) {
  return phpRequest({
    url: '/phpcas/api/user/updatePass',
    method: 'post',
    data: qs.stringify(params)
  })
}
//更新用户信息
export function updateUserInfo(params) {
  return phpRequest({
    url: '/phpcas/api/user/updateUser',
    method: 'post',
    data: qs.stringify(params)
  })
}

//用户消息分页信息
export function userMsgList(params) {
  return phpRequest({
    url: '/phpcas/header/userMsgList',
    method: 'get',
    params: params
  })
}


//获取未读消息数
export function unreadMsgCount(params) {
  return phpRequest({
    url: '/phpcas/api/user/msgBadge2',
    method: 'get',
    params: params
  })
}
//阅读消息接口
export function readUserMsg(params) {
  return phpRequest({
    url: '/phpcas/header/readUserMsg',
    method: 'post',
    data: qs.stringify(params)
  })
}

export function initRequestObj(requestObj) {
  request = requestObj;
}



// WEBPACK FOOTER //
// ./src/api/header.js